import * as ActionConfigurationManager from './config.actions';

export const cookiesAccepted = ActionConfigurationManager.ACCEPT_COOKIES
export const cookiesDeclined = ActionConfigurationManager.DECLINE_COOKIES
